// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"489dbfa4","344":"62742e71","592":"7af83227","636":"57632cd3"}[chunkId] + ".chunk.js";
};